<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar 
      title="纪念馆音乐" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->
  
    <audio id="audio2" class="audio" :src="music" controls autoplay="autoplay" hidden="true"></audio>
    <div>
      <van-tabs sticky animated swipeable offset-top="46" title-active-color="#fff" title-inactive-color="#f2f2f2" background="#24a378" color="#fff" :border="false">
        <van-tab title="系统音乐">
          <!-- <router-link to="/MusicDetails" class="audio-list" v-for="item in 5" :key="item.id">
            <div class="hd">
              <i class="fa fa-music fa-2x"></i>
            </div>
            <div class="bd">
              <div class="title">记录这一刻</div>
              <p class="date">2016-01-06 14:46:12</p>
            </div>
            <div class="ft" v-if="item == 2">
              <van-icon name="checked" size="24" color="#555" />
            </div>
          </router-link> -->
          <system_music_list 
          v-on:changemusic="changemusic" />
        </van-tab>
        <van-tab title="我上传的音乐">
          <!-- <router-link to="/MusicDetails" class="audio-list" v-for="item in 2" :key="item.id">
            <div class="hd">
              <i class="fa fa-music"></i>
            </div>
            <div class="bd">
              <div class="title">记录这一刻</div>
              <p class="date">2016-01-06 14:46:12</p>
            </div>
          </router-link> -->
          <upload_music_list 
          v-on:changemusic="changemusic" />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script> 
import system_music_list from '@/components/music/system_music_list'
import upload_music_list from '@/components/music/upload_music_list'
	export default {
	  data() {
	    return {
        // music:"http://mp3.9ku.com/mp3/352/351169.mp3",
        music:"",
	    };
    },
    watch:{
      isPlaying(){
       let oAudio = document.querySelector("#audio2");
       this.$nextTick(() => {
        this.$store.state.isPlaying2 ? oAudio.play():oAudio.pause();
       })
      }
    },
    computed:{
      isPlaying(){
        return this.$store.state.isPlaying2;
      },

    },
    //被创建
    mounted:function(){
      // this.$store.state.isPlaying2 = true
      let oAudio = document.querySelector("#audio2");
      if(this.$store.state.isPlaying2){
        oAudio.play();
      }else{
        oAudio.pause();
      }
    },
    activated:function(){
      let oAudio = document.querySelector("#audio2");
      if(this.$store.state.isPlaying2){
        oAudio.play();
      }else{
        oAudio.pause();
      }
    },
	  components: {
      system_music_list,
      upload_music_list
    },
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
      },
      changemusic: function (music){
        this.music = music;
        let oAudio = document.querySelector("#audio2");
        if(this.$store.state.isPlaying2){
          oAudio.play();
        }else{
          oAudio.pause();
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      let oAudio = document.querySelector("#audio");
      oAudio.pause();
      next();
    },
    beforeRouteLeave(to, from, next) {
      let oAudio = document.querySelector("#audio");
      this.$store.state.isPlaying ? oAudio.play() : oAudio.pause();
      
      
      next();
    }
	};
</script>

<style scoped>
.audio-list{
  margin: 15px;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  padding:10px;
}
.audio-list>.hd{
  position: relative;
  margin-right: 15px;
}
.audio-list>.hd>i{
  color: #666;
  font-size: 24px;
}
.audio-list>.bd{
  flex: 1;
  overflow: hidden;
}
.audio-list>.bd>.title{
  font-size: 15px;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-list>.bd>.date{
  font-size: 12px;
  color: #aaa;
  font-weight: normal;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.audio-list>.ft{
  margin-left: 10px;
}
</style>
